import React from "react"
import { AvaliacaoDeliveryContextProvider } from "./context/AvaliacaoDeliveryContextProvider"
import { AvaliacaoDelivery } from "./AvaliacaoDelivery"

export function Index() {
    return (
        <AvaliacaoDeliveryContextProvider>
            <AvaliacaoDelivery />
        </AvaliacaoDeliveryContextProvider>
    )
}
